import request from "@/utils/request";

export function login(data) {
  return request.post("/login", data, { noToken: true, loading: true });
}

export function getUserInfo(data) {
  return request.get("/userInfo", data, { loading: true });
}

export function uploadImg(data) {
  return request.post("/bsFile/upload", data, { loading: true });
}

export function delImgApi(id) {
  return request.delete("/bsFile/" + id, {}, { loading: true });
}

export function getPolicy() {
  return request.get("/agreement", {}, { noToken: true, loading: true });
}

export function getPrivacy() {
  return request.get("/privacy", {}, { noToken: true, loading: true });
}

export function sendCode(params) {
  return request.get("/sendCode", params, { noToken: true, loading: true });
}

export function register(data) {
  return request.post("/register", data, { noToken: true, loading: true });
}

export function forgetPassword(data) {
  return request.put("/forgetPassword", data, {
    noToken: true,
    loading: true
  });
}

export function getVipType(data) {
  return request.post("/app/bsmember/get/effective", data, { loading: true });
}

export function bindPhone(data) {
  return request.put("/bindPhone", data, {
    loading: true
  });
}

export function bindUserAccount(data) {
  return request.put("/bindUserAccount", data, {
    loading: true
  });
}

export function getArea(data) {
  return request.get("/bsArea/tree", data, {
    loading: true
  });
}

export function addOpinion(data) {
  return request.post("/bsOpinion/add", data, {
    loading: true
  });
}

export function getDict(data) {
  return request.post("/bsDic/getList", data, {
    loading: true
  });
}

export function toZhiFuBaoPay(id) {
  return request.get(
    "/app/zhiFuBao/toZhiFuBaoPay/" + id,
    {},
    {
      loading: true
    }
  );
}

export function getVipHistory(data) {
  return request.post("/app/bsmember/page/member/record", data, {
    loading: true
  });
}

export function getVipAiHistory(data) {
  return request.post("/app/bsmember/page/ainum/change", data, {
    loading: true
  });
}

export function getVipNum(data) {
  return request.get(
    "/app/bsmember/app/ainum/remain",
    {},
    {
      loading: true
    }
  );
}

export function getvipInfo(data) {
  return request.get(
    "/vipInfo",
    {},
    {
      loading: true
    }
  );
}

export function getConfigByCode(code) {
  return request.get(
    "/bsConfig/getByCode/" + code,
    {},
    {
      loading: true
    }
  );
}

export function getConfigByCodeV1(code) {
  return request.get(
    "/bsConfig/getByCode/V1/" + code,
    {},
    {
      loading: true
    }
  );
}

export function getUserList() {
  return request.get(
    "/userlist",
    {},
    {
      loading: true
    }
  );
}

export function setUser(id) {
  return request.get(
    "/changeuser/" + id,
    {},
    {
      loading: true
    }
  );
}

export function getCaptcha(params) {
  return request.get("/captcha/image", params, {
    loading: true
  });
}

export function toWexinPay(id) {
  return request.get(
    "/app/weiXin/createQRCode/" + id,
    {},
    {
      loading: true
    }
  );
}
